export function helpsCardsToggle() {
  document.addEventListener('DOMContentLoaded', () => {
    const isTouch = window.matchMedia('(hover: none), (pointer: coarse)').matches;

    if (!isTouch) {
      document
        .querySelectorAll('.helps-pages .help-card .help-card__extra[hidden]')
        .forEach(el => el.removeAttribute('hidden'));
      return;
    }

    document.querySelectorAll('.helps-pages .help-card').forEach((card) => {
      const toggleBtn = card.querySelector('.help-card__toggle');
      const extra     = card.querySelector('.help-card__extra');
      const mainLink  = card.querySelector('a');
      if (!toggleBtn) return;

      card.classList.remove('is-open');
      if (extra) extra.hidden = true;

      const openCard = () => {
        card.classList.add('is-open');
        toggleBtn.setAttribute('aria-expanded', 'true');
        if (extra) extra.hidden = false;
      };
      const closeCard = () => {
        card.classList.remove('is-open');
        toggleBtn.setAttribute('aria-expanded', 'false');
        if (extra) extra.hidden = true;
      };

      toggleBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (card.classList.contains('is-open')) {
          closeCard();
        } else {
          document.querySelectorAll('.helps-pages .help-card.is-open').forEach(c => {
            if (c !== card) c.classList.remove('is-open');
          });
          openCard();
        }
      });

      if (mainLink) {
        mainLink.addEventListener('click', (e) => {
          if (!card.classList.contains('is-open')) {
            e.preventDefault();
            openCard();
          }
        });
      }

      document.addEventListener('click', (e) => {
        if (!card.classList.contains('is-open')) return;
        if (card.contains(e.target)) return;
        closeCard();
      });
    });
  });
}